export var BoxShadow;
(function (BoxShadow) {
    BoxShadow["S"] = "2px 2px 10px rgba(0, 0, 0, .1)";
    BoxShadow["M"] = "4px 4px 20px rgba(0, 0, 0, .1)";
    BoxShadow["L"] = "6px 6px 40px rgba(0, 0, 0, .1)";
})(BoxShadow || (BoxShadow = {}));
